export default "__VITE_ASSET__CW3kZkWe__"